import AnimationFrame from "../graphics/AnimationFrame";
import { Color } from "../graphics/Color";
import { Graphics2D } from "../graphics/Graphics2D";
import { Range, RangeType } from "../graphics/Range";
import { ParticleManager, vfx } from "../graphics/VFX";

export class ConfettiRenderer implements AnimationFrame {
  private readonly graphics: Graphics2D;
  constructor(
    private readonly canvas: HTMLCanvasElement,
    private readonly shareState: { active: boolean }
  ) {
    this.canvas = canvas;
    this.canvas.width = canvas.clientWidth;
    this.canvas.height = canvas.clientHeight;
    this.graphics = new Graphics2D(this.canvas);
    this.manager = new ParticleManager(this.graphics);
    this.confetti = new Confetti(this.manager);
  }

  public initialize() {}

  public update(elapsedTime: number) {
    if (this.shareState.active) {
      this.confetti.update(elapsedTime);
    }
  }

  public draw(elapsedTime: number) {
    this.graphics.clear(Color.Transparent);
    this.confetti.draw(this.graphics);
  }

  private readonly confetti: Confetti;
  private readonly manager: ParticleManager;
}

class Confetti {
  // 動作ごとの乱数幅設定
  private readonly items = [
    new vfx.EmitterRectItem(
      new Range(RangeType.Span, 0, 0),
      new Range(RangeType.Span, -100, -50)
    ),
    new vfx.VelocityItem(
      new Range(RangeType.PlusMinus, 0, 0),
      new Range(RangeType.PlusMinus, 100, 50)
    ),
    new vfx.NoiseItem(
      new Range(RangeType.PlusMinus, 1, 0),
      new Range(RangeType.PlusMinus, 0, 0),
      new Range(RangeType.Span, 0.5, 1.0),
      new Range(RangeType.Span, 50, 150),
      new Range(RangeType.Span, 3.0, 4.0),
      new Range(RangeType.Span, 10, 20)
    ),
    new vfx.SizeItem(
      new Range(RangeType.PlusMinus, 20, 0),
      new Range(RangeType.PlusMinus, 30, 0),
      new Range(RangeType.Span, 0.8, 1.1)
    ),
    new vfx.RotateAnimItem(
      new Range(RangeType.Span, 90, 360),
      new Range(RangeType.Span, 90, 360),
      new Range(RangeType.Span, 90, 360)
    ),
    new vfx.ColorTableItem([
      Color.RitchOrange,
      Color.SmokeBlue,
      Color.RitchRed,
      Color.RitchGreen,
    ]),
    new vfx.CardItem(
      new Range(RangeType.PlusMinus, 0.0, 0.0),
      new Range(RangeType.PlusMinus, 0.6, 0.0)
    ),
    new vfx.ScreenOutVanishItem(),
  ];

  // パーティクルを出すやつら
  private readonly emits = [
    new vfx.SpawnBiasItem(1000),
    new vfx.SpawnItem(
      new Range(RangeType.Span, 4, 6),
      new Range(RangeType.Span, 0.3, 0.8)
    ),
    new vfx.EmitterRectWidthFullItem(),
  ];

  private emitter: vfx.Emitter;
  constructor(private readonly manager: ParticleManager) {
    this.emitter = new vfx.Emitter(manager, this.emits, this.items);
  }

  public update(elapsedTime: number) {
    this.emitter.update(elapsedTime);
  }

  public draw(graphics: Graphics2D) {
    this.emitter.draw(graphics);
  }
}

export default ConfettiRenderer;
